import { EndsIn, OfferHasExpired, StartsOn, ViewMore, BlankPageTips, GoShopping } from "./texts";
import { isLocalDevelop } from "utils/debug";
import { getRuntime } from "utils/runtime";
import {
	StatusONE,
	StatusTwo,
	StatusThree,
	StatusFour,
	ReceivedSuccess,
	OKText,
	CouponSuccessfullyCopied,
} from "./coupon";
const mutilLanTextMap: { [key: string]: any } = {
	"Starts On": StartsOn,
	"Ends In": EndsIn,
	"We‘re sorry，the offer has expired.": OfferHasExpired,
	"Awesome Coupons are at your fingertips!": StatusONE,
	"These Coupons have run out. <br/>Check back soon! More surprises waiting for you everyday!":
		StatusTwo,
	"You have already got these Coupons. <br/>Please come back tomorrow.": StatusThree,
	"Check your <a href=\"%s\">Coupons</a> account now.": StatusFour,
	"Received successfully": ReceivedSuccess,
	OK: OKText,
	"Coupon successfully copied": CouponSuccessfullyCopied,
	"Page is blank": BlankPageTips,
	GoShopping: GoShopping,
	"View More": ViewMore,
};

export function getLitbLangFn(keyValues: string, lang: string = "en") {
	const langSource: { [key: string]: string } = mutilLanTextMap[keyValues] || {};
	if (!langSource) {
		return keyValues;
	}
	return langSource[lang] || langSource.en;
}
export function onChangeHeaderLang(lan: string) {
	let routerHref: string = location.href.slice(0);
	const originHref = routerHref;
	if (routerHref.match(/com(?!\/active)/gi)) {
		routerHref = routerHref.replace(/\/\w+\/active/, `/${lan}/active`);
	}

	if (isLocalDevelop(getRuntime()?.hostname)) {
		routerHref = routerHref.replace(/\/\w+\/active/g, `/${lan}/active`);
	}
	if (originHref === routerHref) {
		location.reload();
	} else {
		location.replace(routerHref);
	}
}
